import { render, staticRenderFns } from "./HomeResellerAdmin.vue?vue&type=template&id=6a746991"
import script from "./HomeResellerAdmin.vue?vue&type=script&lang=js"
export * from "./HomeResellerAdmin.vue?vue&type=script&lang=js"
import style0 from "./HomeResellerAdmin.vue?vue&type=style&index=0&id=6a746991&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports